import React from 'react';
import { useSelector } from 'react-redux';
import { List } from '@material-ui/core';
import menu from '../../config/menu';
import currentUserSelector from '../../../../../selectors/currentUserSelector';
import { subscriptionInfoSelector } from '../../../../../selectors/subscription';
import MenuItem from './menuItem';

import useStyles from '../../styles/sideMenu.styles';


const MenuList = ({ isMenuOpen }) => {
  const styles = useStyles();
  const currentUser = useSelector(currentUserSelector);
  const subscriptionDetails = useSelector(subscriptionInfoSelector);
  const { teamManagement,name } = subscriptionDetails || {};
  
  const setVisibility = (item) =>{
    let checkAble = false;
    if((name=="Professional" && item.name=="team") || item.userRole.indexOf(currentUser?.userRole?.toString()) === -1)
    {
      checkAble = true;
    }
    else{
      checkAble = false;
    }
    console.log("pkg info",name,checkAble)
    return (
      <MenuItem
            key={item.name}
            isMenuOpen={isMenuOpen}
            item={item}
            isDisabled={checkAble} />
    )
  }

  return (
    <nav>
      <List>
        {/* {menu.map(item => <MenuItem key={item.name} isMenuOpen={isMenuOpen} item={item} isDisabled={ item.name === 'team' ? !moduleState[item.name] : item.isDisabled} />)} */}
        {menu.map(item =>
        setVisibility(item)
          )
            }
      </List>
    </nav>
  );
};


export default MenuList;
